//#region src/appConfig/appFeaturesMemory.ts
var e = "app-config:features", t = null, n = null, r = !1, i = (e) => typeof e == "object" && !!e && typeof e.slot_kinds_enabled == "boolean", a = (e) => {
	t = e, n = null, r = !1;
}, o = () => {
	if (n) return n;
	if (r) return null;
	r = !0;
	try {
		let r = t?.read(e);
		if (!r) return null;
		let a = JSON.parse(r);
		return i(a) ? (n = a, a) : null;
	} catch {
		return null;
	}
}, s = (i) => {
	n = i, r = !0;
	try {
		t?.write(e, JSON.stringify(i));
	} catch {}
};
//#endregion
export { e as APP_FEATURES_STORAGE_KEY, o as readRememberedAppFeatures, a as registerAppFeaturesStorage, s as rememberAppFeatures };
